<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" :id="id" ref="echarts-bar"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    pieData: {
      type: Array,
      default() {
        return [];
      }
    },
    text:String,
    subtext: String,
    id:String
  },
  data() {
    return {};
  },
  watch: {
    pieData() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let $echartsDOM = document.getElementById(this.id);
      let myEcharts = this.$echarts.init($echartsDOM);
      let option = {
        backgroundColor: "#ffffff",
        color: [
          "#698EFF",
          "#FF8E55",
          "#9785ED",
          "#FFCC5C",
          "#FF7B74",
          "#4ACAA8",
          "#D7A4F6",
          "#FAEE00",
          "#64CCFF",
          "#E89242",
          "#FF76AE",
          "#8DE034"
        ],
        title: {
          text: this.subtext?this.text+"\n"+this.subtext:this.text,
          // x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: "center",
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: "center",
          backgroundColor: "rgba(255,255,255,0)",
          // 主标题文本样式设置
          textStyle: {
            fontSize: 12,
            height: 19,
            lineHeight: 19,
            color: "#111111"
          }
        },
        series: [
          {
            name: "",
            minAngle: 30,
            avoidLabelOverlap: true,
            label: {
              fontSize: 14,
              formatter: "{b|{b}}\n{a|{d}%}",
              borderWidth: 20,
              borderRadius: 4,
              padding: [0, -75],
              rich: {
                a: {
                  color: "#333",
                  fontSize: 10,
                  lineHeight: 14,
                  align: "left"
                },
                b: {
                  fontSize: 10,
                  lineHeight: 14,
                  color: "#333",
                  align: "left"
                }
              }
            },
            type: "pie",
            center: ["50%", "50%"],
            radius: ["35%", "45%"],
            labelLine: {
              normal: {
                length: 10,
                length2: 75
              }
            },
            data: this.pieData,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#fff"
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 2, 2, 0.3)"
              }
            }
          }
        ]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_pie/index.vue